/* Addlore reviews — logic only.
   20-09-2026: moved out of snippets/adl-reviews-js.liquid. 13 KB of JavaScript was written into
   every page's HTML, which the browser had to read before it could paint. The one Liquid value
   it used (sp, the star paths) is handed over on window.ADL_SP by the inline line that remains.
   Loaded with `defer`: off the critical path, still runs before DOMContentLoaded. */

(function(){
  var root=document.querySelector('.adlrv'); if(!root) return;
  var DATA=[];
  var MARK=getComputedStyle(root).getPropertyValue('--m').trim();
  var SP=window.ADL_SP||'';
  var BREAKS=(root.dataset.breaks||'').split('|').filter(Boolean);
  var CATS=[['all','All'],['use','Use &amp; effect'],['taste','Taste'],['packaging','Packaging'],['value','Price &amp; value'],['gifting','Gifting']];
  var st={q:'',sort:'media',chip:'all',photo:false,video:false,page:1},PER=12;
  var $=function(s){return root.querySelector(s)};

  var RE_CLAIM=/\b(sleep|slept|sleeping|asleep|awake|insomnia|drowsy|drowsiness|focus|focused|energy|energ|alert|desire|libido|intimacy|arousal|stamina|erection|performance|mood|anxiety|anxious|depress|stress|dose|dosage|mg|milligram|melatonin|cordyceps|ashwagandha|maca|caffeine|reishi|magnesium|theanine|phosphatidylserine|lion|onset|minutes|hours|cure|cures|treat|treats|heal|remedy|therapeutic|nootropic|supplement)\b/i;
  function quotes(){
    return DATA.filter(function(r){
      var b=(r.b||'').trim();
      return b.length>=60 && b.length<=150 && (+r.r)>=4 && !RE_CLAIM.test(b) && b.indexOf('"')<0;
    }).map(function(r){return {b:(r.b||'').trim(), n:r.n, c:r.c};});
  }
  var QUOTES=[];

  function stars(pct,w,h){
    return '<span class="adlrv-stars" style="height:'+h+'px;width:'+w+'px">'
      +'<span class="adlrv-star-e"><svg width="'+w+'" height="'+h+'" viewBox="0 0 120 24" fill="none" stroke="rgba(26,26,26,.26)" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true">'+SP+'</svg></span>'
      +'<span class="adlrv-star-f" style="width:'+pct+'%"><svg width="'+w+'" height="'+h+'" viewBox="0 0 120 24" fill="'+MARK+'" stroke="'+MARK+'" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true">'+SP+'</svg></span></span>';
  }
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function summary(){
    var n=DATA.length;
    if(n===0){ $('[data-summary]').hidden=true; $('[data-controls]').hidden=true; return; }
    $('[data-summary]').hidden=false; $('[data-controls]').hidden=false;
    /* 22-09-2026, Ajay: the page reports WHAT IT CAN SHOW.
       Until today the headline took Judge.me's totals (avg 4.58 / 50) so it matched the product
       page and its structured data, while the list held 48 - reviews carrying a banned claim
       term are never rendered. The page then contradicted itself in three places on one screen:
       "50 REVIEWS" above bars adding to 48 above a tab reading ALL 48.
       Both figures are now computed from the rows actually rendered. Known consequence, stated:
       the product page and Google still show Judge.me's 50, so the two differ. That is the
       founder's call, taken with the trade-off in front of him. */
    var a=DATA.reduce(function(t,r){return t+(+r.r||0)},0)/n;
    $('[data-avg]').textContent=a.toFixed(2);
    $('[data-avgfill]').style.width=(a/5*100)+'%';
    var NF=(function(){ try{ return new Intl.NumberFormat(document.documentElement.lang||'en-IN'); }catch(e){ return {format:function(x){return String(x)}}; } })();
    $('[data-avg]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en-IN',{minimumFractionDigits:2,maximumFractionDigits:2}).format(a);
    $('[data-total]').textContent = '\u00b7 '+NF.format(n)+(n===1?' review':' reviews');
    /* proof line - both counted off the same rendered rows, never asserted */
    var nPhoto=DATA.filter(function(r){return r.img}).length;
    var bits=[];
    if(nPhoto) bits.push('\u00b7 '+nPhoto+(nPhoto===1?' with a photo':' with photos'));
    var sp=$('[data-proof]'); if(sp) sp.textContent=bits.join('  \u00b7  ');
    var sr=root.querySelector('[data-sticky-rating]');
    if(sr) sr.textContent=a.toFixed(2)+' / '+n;
    strip();
    var d='';
    [5,4,3,2,1].forEach(function(s){
      var c=DATA.filter(function(r){return +r.r===s}).length;
      d+='<div class="adlrv-drow"><span class="num">'+s+' star</span><span class="adlrv-dbar"><i style="width:'+Math.round(c/n*100)+'%"></i></span><span class="num">'+c+'</span></div>';
    });
    $('[data-dist]').innerHTML=d;
  }
  function chips(){
    var h='';
    CATS.forEach(function(c){
      var n=c[0]==='all'?DATA.length:DATA.filter(function(r){return (r.t||[]).indexOf(c[0])>=0}).length;
      h+='<button type="button" class="adlrv-chip" data-chip="'+c[0]+'" aria-pressed="'+(st.chip===c[0])+'"'+(n===0&&c[0]!=='all'?' disabled':'')+'>'+c[1]+' <b class="num">'+n+'</b></button>';
    });
    $('[data-chips]').innerHTML=h;
  }
  function filtered(){ return !!(st.q||st.chip!=='all'||st.photo||st.video); }
  function list(){
    var out=DATA.slice();
    if(st.chip!=='all') out=out.filter(function(r){return (r.t||[]).indexOf(st.chip)>=0});
    if(st.photo) out=out.filter(function(r){return r.img});
    if(st.video) out=out.filter(function(r){return r.vid});
    var q=st.q.trim().toLowerCase();
    if(q) out=out.filter(function(r){return ((r.b||'')+' '+(r.n||'')+' '+(r.c||'')).toLowerCase().indexOf(q)>=0});
    if(st.sort==='high') out.sort(function(a,b){return b.r-a.r});
    if(st.sort==='low') out.sort(function(a,b){return a.r-b.r});
    if(st.sort==='helpful') out.sort(function(a,b){return (b.h||0)-(a.h||0)});
    /* 'With photos first' = Ajay's 'best reviews and photos first' (16-09-2026): photo reviews,
       then 4-5 stars before 3 and below, then more (curated) photos, then newest. */
    var TOP=(MEDIA.top||[]), ti=function(r){var i=TOP.indexOf((r.id||'').slice(0,8)); return i<0?999:i;};
    /* the product page's hand-picked 10 lead, in the same order (Ajay, 16-09-2026) */
    if(st.sort==='media') out.sort(function(a,b){return (ti(a)-ti(b)) || ((b.img?1:0)-(a.img?1:0)) || ((b.r>=4?1:0)-(a.r>=4?1:0)) || ((b.imgs||[]).length-(a.imgs||[]).length) || (b.ts||'').localeCompare(a.ts||'')});
    return out;
  }
  function card(r){
    var media='';
    if(r.img||r.vid){
      var th=(r.imgs&&r.imgs.length>1)?'<div class="adlrv-thumbs">'+r.imgs.map(function(u,i){return '<button type="button" class="adlrv-th'+(i===0?' on':'')+'" data-src="'+esc(u)+'" aria-label="Show photo '+(i+1)+' of '+r.imgs.length+'"><img src="'+esc(u.replace('_600x','_120x'))+'" alt="" loading="lazy"></button>';}).join('')+'</div>':'';
      media='<div class="adlrv-media-box">'+(r.img?'<img class="adlrv-main" src="'+esc(r.img)+'" alt="'+esc(r.alt||('Customer photo of Addlore '+root.dataset.product))+'" loading="lazy">':'')+(r.imgs&&r.imgs.length>1?'<span class="adlrv-cnt">'+r.imgs.length+' photos</span>':'')
        +(r.vid?'<span class="adlrv-play"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0F0C0B" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><path d="M8 5.5 19 12 8 18.5z"/></svg></span>':'')+'</div>'+th;
    }
    return '<article class="adlrv-card" data-rvid="'+esc(r.id)+'">'+media+'<div class="adlrv-body">'
      +'<div class="adlrv-cardtop"><span aria-label="'+r.r+' out of 5">'+stars(r.r/5*100,66,13)+'</span><span class="adlrv-date num">'+esc(r.d||'')+'</span></div>'
      +'<p class="adlrv-text">'+(r.tt?'<strong>'+esc(r.tt)+'</strong><br>':'')+esc(r.b).replace(/\n/g,'<br>')+'</p>'
      +'<div class="adlrv-who"><span class="adlrv-name">'+esc(r.n)+(r.c?' <i>&middot; '+esc(r.c)+'</i>':'')+'</span>'
      +(r.vf?'<span class="adlrv-vf"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#8A8177" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5 9.5 18 20 6.5"/></svg>Verified purchase</span>':'')
      +'</div></div></article>';
  }
  function brk(i){
    if(BREAKS.length) return '<figure class="adlrv-break"><img src="'+esc(BREAKS[i%BREAKS.length])+'" alt="Addlore '+esc(root.dataset.product)+'" loading="lazy"></figure>';
    if(!QUOTES.length) return '';
    var q=QUOTES[i%QUOTES.length];
    return '<figure class="adlrv-break adlrv-break-q"><blockquote class="adlrv-quote">&ldquo;'+esc(q.b)+'&rdquo;</blockquote>'
      +'<figcaption class="adlrv-quote-who">'+esc(q.n)+(q.c?' &middot; '+esc(q.c):'')+'</figcaption></figure>';
  }
  function render(){
    var out=list(), shown=out.slice(0,PER*st.page), g=$('[data-grid]'), h='', br=0;
    var wantBreaks = !filtered();
    shown.forEach(function(r,i){
      h+=card(r);
      if(wantBreaks && (i+1)%12===0 && i+1<shown.length){ h+=brk(br); br++; }
    });
    g.innerHTML=h;
    g.hidden = shown.length===0;
    $('[data-result]').textContent = DATA.length===0 ? '' : ('Showing '+shown.length+' of '+out.length+(filtered()?' matching reviews':' reviews'));
    $('[data-empty]').hidden = !(DATA.length>0 && out.length===0);
    $('[data-more]').hidden = shown.length>=out.length;
  }
  $('[data-q]').addEventListener('input',function(e){st.q=e.target.value;st.page=1;render()});
  $('[data-sort]').addEventListener('change',function(e){st.sort=e.target.value;st.page=1;render()});
  $('[data-more]').addEventListener('click',function(){st.page++;render()});
  $('[data-grid]').addEventListener('click',function(e){
    var b=e.target.closest('.adlrv-th'); if(!b) return;
    var card=b.closest('.adlrv-card'), main=card&&card.querySelector('.adlrv-main'); if(!main) return;
    main.src=b.getAttribute('data-src');
    card.querySelectorAll('.adlrv-th').forEach(function(x){x.classList.toggle('on',x===b)});
  });
  root.querySelectorAll('[data-media]').forEach(function(b){
    b.addEventListener('click',function(){ st[b.dataset.media]=!st[b.dataset.media];
      b.setAttribute('aria-pressed',String(st[b.dataset.media])); st.page=1; render(); });
  });
  $('[data-chips]').addEventListener('click',function(e){
    var b=e.target.closest('[data-chip]'); if(!b) return;
    st.chip=b.dataset.chip; st.page=1; chips(); render();
  });
  /* THE PHOTO RAIL - the first screen's proof, built from the rows that carry photos, in the
     same order the grid uses. No stock photography, no marketing creative: only pictures real
     customers attached. Capped at 10 so the rail stays one swipe. */
  function strip(){
    var box=root.querySelector('[data-strip]'), rail=root.querySelector('[data-strip-rail]');
    if(!box||!rail) return;
    var withPics=DATA.filter(function(r){return r.img});
    var TOP=(MEDIA.top||[]), ti=function(r){var i=TOP.indexOf((r.id||'').slice(0,8)); return i<0?999:i;};
    withPics.sort(function(a,b){return (ti(a)-ti(b)) || ((b.r>=4?1:0)-(a.r>=4?1:0)) || (b.ts||'').localeCompare(a.ts||'')});
    if(!withPics.length){ box.hidden=true; return; }
    box.hidden=false;
    rail.innerHTML=withPics.slice(0,10).map(function(r){
      return '<button type="button" class="adlrv-sp" data-go="'+esc(r.id)+'" aria-label="Read the review by '+esc(r.n||'a customer')+'">'
        +'<img src="'+esc(r.img)+'" alt="'+esc(r.alt||('Customer photo of Addlore '+root.dataset.product))+'" width="88" height="88" loading="eager" decoding="async" fetchpriority="high">'
        +'<span class="adlrv-sp-r">'+esc(r.n||'')+'</span></button>';
    }).join('');
  }
  /* a rail photo jumps to that review. If it is not rendered yet, turn the photo filter on and
     go to the grid - everything that looks tappable has to do something. */
  root.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.adlrv-sp'); if(!b) return;
    var el=root.querySelector('[data-rvid="'+b.getAttribute('data-go')+'"]');
    if(!el){ st.photo=true; st.page=1;
      var pb=root.querySelector('[data-media="photo"]'); if(pb) pb.setAttribute('aria-pressed','true');
      render(); el=root.querySelector('[data-rvid="'+b.getAttribute('data-go')+'"]'); }
    var calm=matchMedia('(prefers-reduced-motion: reduce)').matches;
    (el||$('[data-grid]')).scrollIntoView({behavior:calm?'auto':'smooth',block:'center'});
  });
  /* sticky bar: shown once the hero CTA has scrolled past, hidden again at the closing CTA so
     the two never stack. Reacts to the visitor scrolling; it never changes what the page says. */
  (function(){
    var bar=root.querySelector('[data-sticky]'); if(!bar) return;
    var hero=root.querySelector('#adlrv-add-form'), close=root.querySelector('.adlrv-close');
    if(!hero) return;
    var tick=false;
    function upd(){
      tick=false;
      var hb=hero.getBoundingClientRect().bottom;
      var cv=close ? close.getBoundingClientRect().top < window.innerHeight : false;
      bar.hidden = !(hb < 0 && !cv);
    }
    addEventListener('scroll',function(){ if(!tick){ tick=true; requestAnimationFrame(upd); } },{passive:true});
    addEventListener('resize',upd,{passive:true});
    upd();
  })();
  /* Pending state on every Add to cart on this page. adl-cart-hook intercepts the submit and
     posts by fetch, so without this the button looks inert and a second tap adds a second tin.
     Guideline: submit stays enabled until the request starts, then shows progress. */
  root.addEventListener('submit',function(e){
    var f=e.target; if(!f||!f.classList||!f.classList.contains('adlrv-buyform')) return;
    var b=f.querySelector('button[type="submit"]'); if(!b||b.getAttribute('aria-busy')==='true') return;
    var label=b.innerHTML;
    b.setAttribute('aria-busy','true'); b.innerHTML='Adding\u2026';
    setTimeout(function(){ b.removeAttribute('aria-busy'); b.innerHTML=label; },2500);
  },true);
  /* LOAD - Judge.me's public widget feed, every page of it (added 16-09-2026). Topics use
     the same keyword rules as the product page's reviews_top metafield. */
  var RULES={use:/\b(sleep\w*|slept|calm\w*|relax\w*|focus\w*|energ\w*|alert\w*|mood\w*|effect\w*|work(ed|s)?|help\w*|stress\w*|drows\w*|clarity|groggy|unwind\w*|brain fog|boost\w*|restful|awake)\b/i,
    taste:/\b(tast\w*|flavou?r\w*|bitter\w*|sweet\w*|creamy|smooth\w*|texture\w*|chalky|aftertaste|delicious|cocoa|cacao|rich)\b/i,
    packaging:/\b(pack\w*|tins?|box\w*|case|cases|pouch|wrap\w*)\b/i,
    value:/\b(price\w*|pric\w*|value|money|expensive|cost\w*|worth|rs\.?|rupees?)\b|₹/i,
    gifting:/\b(gift\w*|present|anniversar\w*|birthday|hamper\w*|date night\w*|partner)\b/i};
  var MON=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  /* Curated photos and hidden reviews (16-09-2026): product metafield addlore.reviews_media,
     printed by the template. Photos were copied into Shopify Files and reviewed by eye; bad ones
     are left out, best first. A review whose text carries a Tier-1 banned term never renders. */
  var MEDIA={}; try{ MEDIA=JSON.parse(root.dataset.media||'{}')||{}; }catch(err){ MEDIA={}; }
  var BANNED=/horny goat weed|epimedium|icariin|barrenwort|yin yang huo|aphrodisiac|libido|arousal|blood flow|viagra|erectile|impotence/i;
  function photos(id){
    var k=(id||'').slice(0,8), m=(MEDIA.m||{})[k];
    if(!m||!MEDIA.code) return null;
    return m.map(function(n){ return '/cdn/shop/files/adl-rv-'+MEDIA.code+'-'+k+'-'+n+'_600x.jpg'; });
  }
  function clean(el,title){
    var c=el.cloneNode(true);
    c.querySelectorAll('br').forEach(function(b){b.replaceWith('\n')});
    c.querySelectorAll('p,div,li').forEach(function(x){x.append('\n')});
    var t=c.textContent.replace(/The media could not be loaded\./g,'').replace(/[ \t ]+/g,' ').replace(/ *\n */g,'\n').replace(/\n{2,}/g,'\n').trim();
    if(title && t.indexOf(title)===0) t=t.slice(title.length).trim();
    return t.replace(/([a-z\)])([.!?:])([A-Z])/g,'$1$2\n$3');
  }
  function load(page){
    var u='https://api.judge.me/reviews/reviews_for_widget?url='+encodeURIComponent(root.dataset.shop)+'&shop_domain='+encodeURIComponent(root.dataset.shop)+'&platform=shopify&page='+page+'&per_page=10&product_id='+root.dataset.pid;
    return fetch(u).then(function(r){return r.json()}).then(function(j){
      var d=new DOMParser().parseFromString(j.html||'','text/html'), revs=d.querySelectorAll('.jdgm-rev'), added=0, seen={};
      DATA.forEach(function(x){seen[x.id]=1});
      revs.forEach(function(el){
        var id=el.getAttribute('data-review-id'); if(seen[id]) return; added++;
        var tt=((el.querySelector('.jdgm-rev__title')||{}).textContent||'').trim();
        var bodyEl=el.querySelector('.jdgm-rev__body'); var b=bodyEl?clean(bodyEl,tt):'';
        var ts=((el.querySelector('.jdgm-rev__timestamp')||{}).getAttribute||function(){return ''}).call(el.querySelector('.jdgm-rev__timestamp'),'data-content')||'';
        var dm=ts.match(/^(\d{4})-(\d{2})-(\d{2})/);
        var pic=el.querySelector('.jdgm-rev__pics a, .jdgm-rev__pics img');
        var img=pic?(pic.getAttribute('href')||pic.getAttribute('data-mfp-src')||pic.getAttribute('data-src')||pic.getAttribute('src')):'';
        if((MEDIA.hide||[]).indexOf(id.slice(0,8))>-1 || BANNED.test(tt+' '+b)) return;
        var cur=photos(id); var imgs = cur ? cur : ((img&&/^https?:/.test(img))?[img]:[]);
        var txt=tt+' '+b, tags=[];
        Object.keys(RULES).forEach(function(k){ if(RULES[k].test(txt)) tags.push(k); });
        DATA.push({id:id, n:((el.querySelector('.jdgm-rev__author')||{}).textContent||'').trim(),
          r:+((el.querySelector('.jdgm-rev__rating')||{getAttribute:function(){return 0}}).getAttribute('data-score')),
          tt:tt, b:b, t:tags, img:imgs[0]||'', imgs:imgs, ts:ts,
          d: dm ? (+dm[3])+' '+MON[+dm[2]-1]+' '+dm[1] : ''});
      });
      return (added && page<30) ? load(page+1) : null;
    });
  }
  if(root.dataset.pid && root.dataset.shop){
    load(1).then(function(){
      DATA.sort(function(a,b){ return (b.ts||'').localeCompare(a.ts||''); });
      QUOTES=quotes(); summary(); chips(); render();
    }).catch(function(){ summary(); chips(); render(); });
  } else { summary(); chips(); render(); }
})();

